// src/hooks/useAnalysis.js
// Tidak lagi menerima API Key sebagai parameter
// Semua request melalui /api/analyze (Cloudflare Function)

import { useState } from 'react';
import { analyzeText } from '../services/api';
import { DEMO_PESANTREN_ANALYSIS } from '../constants/demoData';

export function useAnalysis(activeProvider) {
  const [loading, setLoading]               = useState(false);
  const [errorMsg, setErrorMsg]             = useState(null);
  const [analysisResult, setAnalysisResult] = useState(DEMO_PESANTREN_ANALYSIS);
  const [isDemoMode, setIsDemoMode]         = useState(true);

  /**
   * Jalankan analisis teks Arab.
   * Tidak perlu API Key — dikelola Cloudflare.
   *
   * @param {string} inputText - Teks Arab yang akan dianalisis
   */
  const analyze = async (inputText) => {
    if (!inputText?.trim()) return;

    setLoading(true);
    setErrorMsg(null);

    try {
      const data = await analyzeText(inputText, activeProvider);
      setAnalysisResult(data);
      setIsDemoMode(false);

    } catch (err) {
      console.error('[useAnalysis] Error:', err);
      setErrorMsg(
        err.message || 'Terjadi kesalahan saat menganalisis.'
      );
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    setAnalysisResult(null);
    setErrorMsg(null);
    setIsDemoMode(false);
  };

  return {
    loading,
    errorMsg,
    analysisResult,
    isDemoMode,
    analyze,
    reset,
    setAnalysisResult,
    setIsDemoMode,
  };
}